import MediaThumbnail from '../../components/MediaThumbnail'
import MediaTypeLabel from '../../components/MediaTypeLabel'
import MediaLibraryButton from '../../components/MediaLibraryButton'
import { IconEdit } from '../../components/ui/Icons'
import { StatusPill } from '../../components/v2/V2Primitives'
import { getMediaPreview } from '../ModelDetail/utils'
import { formatDate } from './v2Utils'

export default function AdminV2MediaTile({ modelId, item, onEdit, onLibrarySaved, selectable = false, selected = false, onSelect, fullQualityThumb = false }) {
  const source = item.source_detail ? `${item.source || 'local'}:${item.source_detail}` : item.source || 'local'
  const preview = getMediaPreview(item, { preferFull: fullQualityThumb })
  const title = item.description || item.external_id || `Media #${item.id}`
  const priceLabel = item.price_min != null || item.price_max != null
    ? `$${item.price_min ?? item.price_max ?? 0}${(item.price_max ?? item.price_min) !== (item.price_min ?? item.price_max) ? `-${item.price_max ?? item.price_min}` : ''}`
    : ''

  return (
    <article className={`v2-media-tile ${selected ? 'is-selected' : ''}`}>
      <div className="v2-media-thumb">
        {selectable ? (
          <label className="v2-media-select" title="Select media">
            <input
              type="checkbox"
              checked={selected}
              onChange={(event) => onSelect?.(item.id, event.target.checked)}
            />
            <span>Select</span>
          </label>
        ) : null}
        {preview ? (
          preview.local ? (
            <MediaThumbnail
              modelId={modelId}
              mediaId={preview.mediaId}
              kind="thumb"
              fallbackKind="preview"
              className="v2-media-thumb-image"
              alt={title}
            />
          ) : (
            <MediaThumbnail modelId={modelId} cdnUrl={preview.cdnUrl} className="v2-media-thumb-image" alt={title} />
          )
        ) : (
          <div className="v2-media-thumb-placeholder">
            <MediaTypeLabel item={item} />
          </div>
        )}
        <button
          type="button"
          className="v2-media-edit-button"
          onClick={() => onEdit?.(item)}
          aria-label="Edit media description"
          title="Edit media description"
        >
          <IconEdit />
        </button>
      </div>
      <div>
        <strong>{title}</strong>
        <p>{formatDate(item.created_at || item.posted_at)}</p>
      </div>
      <div className="v2-media-tags">
        <MediaTypeLabel item={item} />
        <StatusPill tone={item.source === 'fanvue' ? 'warn' : 'neutral'}>{source}</StatusPill>
        <StatusPill tone={item.media_path ? 'good' : item.media_status === 'downloading' ? 'warn' : 'neutral'}>
          {item.media_path ? 'downloaded' : item.media_status || 'metadata'}
        </StatusPill>
        <StatusPill tone={item.description ? 'good' : 'warn'}>{item.description ? 'described' : 'needs description'}</StatusPill>
        <StatusPill tone={item.is_paid ? 'warn' : 'neutral'}>{item.is_paid ? 'paid' : 'free'}</StatusPill>
        {item.is_hidden ? <StatusPill tone="bad">{item.provider_missing_since ? 'provider removed' : 'hidden'}</StatusPill> : null}
        {priceLabel ? <StatusPill tone="good">{priceLabel}</StatusPill> : null}
      </div>
      <MediaLibraryButton modelId={modelId} item={item} onSaved={onLibrarySaved} />
    </article>
  )
}
